/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Commenting",
  size: 20
}

const SvgCommenting = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path fill="none" d="M1.5 1.5h17v12h-8l-4 4v-4h-5z" />
    <circle cx={10} cy={8} r={1} />
    <circle cx={6} cy={8} r={1} />
    <circle cx={14} cy={8} r={1} />
  </Svg>
)

SvgCommenting.defaultProps = defaultProps
export default SvgCommenting
